import React, { Component } from "react";
import Modal from "react-modal";

import { MODAL_COMPONENTS } from "../../constants/modals";

Modal.setAppElement("#root");

class RootModal extends Component {
  render() {
    const { modalType, modalProps } = this.props;

    if (!modalType) {
      return null;
    }

    const ModalComponent = MODAL_COMPONENTS[modalType];

    return (
      <Modal
        isOpen
        portalClassName="modal__portal"
        overlayClassName="modal__overlay"
        className="modal__content"
        bodyOpenClassName="modal__body-open"
        htmlOpenClassName="modal__html-open"
        onRequestClose={this.props.closeModal}
        t={this.props.t}
        lng={this.props.lng}
      >
        <ModalComponent
          t={this.props.t}
          openModal={this.props.openModal}
          handleConfirmModal={this.props.confirmModal}
          handleCloseModal={this.props.closeModal}
          updateUserHasVisited={this.props.updateUserHasVisited}
          openPasswordResetModal={this.props.openPasswordResetModal}
          handleCreateModelExport={this.props.createModelExport}
          modelExport={this.props.modelExport}
          lng={this.props.lng}
          {...modalProps}
        />
      </Modal>
    );
  }
}

export default RootModal;



// WEBPACK FOOTER //
// ./src/components/modals/RootModal.js